import { api, profilePhotouploadDir } from '../config';
const RESTAURANT_AVATAR_BASE_URL = api.serverUrl + '/' + profilePhotouploadDir;

/**
 * Function to generate avatar URL based on filename or user fullName
 * @param {string} avatarFileName avatar filename, e.g default.jpg
 * @returns {string} generated avatar URL
 */

export function getAvatarUrl(avatarFileName){
  return `${RESTAURANT_AVATAR_BASE_URL}${avatarFileName}`;
}

/**
 * Generate UI Avatar URL based on user name
 * @param {String} name
 * @returns {String} Full UI Avatar URL
 */
export const getUiAvatarUrl = (name) => `https://ui-avatars.com/api/?name=${name}`;